







































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/infrastructure/api/movement/movementApi';
import moment from 'moment';

import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import { progress } from '@/script/progress';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import 在庫場所選択型 from '@/type/movement/types/在庫場所選択型';
import 部署間移動修正チェッカー from '@/type/movement/records/modify/部署間移動修正チェッカー';
import {to修正移動型, to移動修正依頼内容型, 修正移動型, 移動修正依頼型, 移動修正検索依頼型, 移動削除依頼型, 移動型, 移動修正検索結果型} from '@/type/movement/records/modify/部署間移動修正削除';
import {移動入力在庫場所型, 移動入力在庫場所結果型} from '@/type/movement/records/register/部署間移動入力';
import 部署間移動修正検索条件チェッカー from '@/type/movement/records/modify/部署間移動修正検索条件チェッカー';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import FixedMovementDataRow from '@/views/movement/fragments/FixedMovementDataRow.vue';

@Component({
  components: {
    ToggleButtonField,
    Datepicker,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    SenderSelector,
    DepartmentSelector,
    FixedMovementDataRow,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    数値フォーマット(value: number): string {
      if (value === null) {
        return '';
      }
      return value.toFixed(3);
    },
  },
})
export default class RegisterMovement extends Vue {
  // data
  在庫場所選択: 在庫場所選択型 = new 在庫場所選択型(this.ログインユーザの部署コード, this.管理者である, this.代行ログインである);

  検索条件: 移動修正検索依頼型 = {...this.デフォルトの検索条件};
  検索結果に対応する検索条件: 移動修正検索依頼型 | null = null;
  検索結果: 移動型[] = [];

  修正対象: 修正移動型[] = [];
  削除対象: 修正移動型 | null = null;

  在庫場所一覧: 移動入力在庫場所型[] = [];
  移動先在庫場所一覧: 移動入力在庫場所型[] = [];

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get ログインユーザの部署コード(): string {
    return loginModule.部署コードを取得する;
  }

  get ログインユーザの利用者コード(): string {
    return loginModule.利用者コードを取得する;
  }

  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 管理者である(): boolean {
    return loginModule.管理者である;
  }

  get 代行ログインである(): boolean {
    return loginModule.マスターである;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 表示件数(): number {
    return this.検索結果.length;
  }

  get デフォルトの検索条件(): 移動修正検索依頼型 {
    return {
      在庫部署コード: this.ログインユーザの部署コード,
      移動先部署コード: null,
      移動年月日検索開始日: moment().startOf('month').toDate(),
      移動年月日検索終了日: null,
      登録者: this.管理者である ? null : this.ログインユーザの利用者コード,
      商品名カナ検索文字列: '',
      メーカー名検索文字列: '',
      検索対象商品区分: null,
      検索対象データ作成区分: null,
    };
  }

  get 外部連携を利用する(): boolean {
    return loginModule.外部連携を利用する;
  }

  @Watch('修正対象', {deep: true})
  リストが変更された() {
    viewEditingStateModule.画面の編集を開始する();
  }

  async 編集を破棄して検索を実行するハンドラ() {
    this.$modal.hide('編集中検索確認ダイアログ');
    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  // methods
  在庫場所を確定する(): void {
    if (this.在庫場所選択.部署コード == null) {
      this.showAlert('在庫場所を選択してください');
      return;
    }
    this.在庫場所選択.確定する();
    this.移動先在庫場所一覧を作成する();
  }

  クリアダイアログを開く(): void {
    this.$modal.show('クリアダイアログ');
  }

  クリアダイアログを閉じる(): void {
    this.$modal.hide('クリアダイアログ');
  }

  削除ダイアログを開く(): void {
    this.$modal.show('削除ダイアログ');
  }

  削除ダイアログを閉じる(): void {
    this.$modal.hide('削除ダイアログ');
  }

  確定ダイアログを開く(): void {
    this.$modal.show('確定ダイアログ');
  }

  確定ダイアログを閉じる(): void {
    this.$modal.hide('確定ダイアログ');
  }

  クリアメッセージ(): string {
    if (viewEditingStateModule.画面を編集中である) {
      return '編集中のデータは破棄されますが、よろしいですか？';
    }
    return 'クリアしますか？';
  }

  async クリア確認する() {
    await this.クリアする()
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  async クリアする(): Promise<void> {
    this.在庫場所選択 = new 在庫場所選択型(this.ログインユーザの部署コード, this.管理者である, this.代行ログインである);


    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果に対応する検索条件 = null;
    this.検索結果 = [];
    this.修正対象 = [];

    this.選択行番号 = null;
    this.アラートメッセージ = null;
    this.クリアダイアログを閉じる();
  }

  検索条件入力エラー判定表示(項目名: string): any {
    return {'input-error': this.検索条件入力エラー判定(項目名)};
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 部署間移動修正検索条件チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  修正あり(修正移動: 修正移動型): boolean {
    if (修正移動.移動.移動先部署コード !== 修正移動.修正移動先部署コード) return true;
    if (!moment(修正移動.移動.移動年月日).isSame(修正移動.修正移動年月日, 'day')) return true;
    if (修正移動.移動.箱数 !== 修正移動.修正箱数) return true;
    if (修正移動.移動.バラ数 !== 修正移動.修正バラ数) return true;
    return false;
  }

  async 在庫場所一覧取得(): Promise<void> {
    this.アラートメッセージ = [];
    // FIXME 権限によって制御が必要？
    await api.移動入力在庫場所一覧を取得する()
      .then((response: 移動入力在庫場所結果型) => {
        this.在庫場所一覧 = response.移動在庫場所結果一覧;
      })
      .catch((error: any) => {
        this.在庫場所一覧 = [];
        this.showAlert(error.data.message);
      });
  }

  async 移動を検索する(): Promise<void> {
    this.検索条件.在庫部署コード = this.在庫場所選択.部署コード;

    const checker = new 部署間移動修正検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    if (viewEditingStateModule.画面を編集中である) {
      this.$modal.show('編集中検索確認ダイアログ');
      return;
    }

    await progress(this.検索処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  async 検索処理(): Promise<void> {
    this.アラートメッセージ = [];
    this.検索結果 = [];
    this.選択行番号 = null;

    await api.移動修正一覧を取得する(this.検索条件)
      .then((response: 移動修正検索結果型) => {
        if (response.移動修正検索結果一覧.length === 0) {
          this.修正対象 = [];
          this.showAlert('検索結果が0件です。');
          return;
        }
        this.検索結果に対応する検索条件 = {...this.検索条件};
        this.検索結果 = response.移動修正検索結果一覧;
        this.修正対象 = response.移動修正検索結果一覧.map((record) => to修正移動型(record));
        if (response.アラートメッセージ) {
          this.showAlert(response.アラートメッセージ);
        }
      })
      .catch((error: any) => {
        this.showAlert(error.data.message);
      });
  }

  編集中検索確認ダイアログを閉じる() {
    this.$modal.hide('編集中検索確認ダイアログ');
  }

  移動の削除を確認する(event: any): void {
    this.削除対象 = event.value;
    this.削除ダイアログを開く();
  }

  移動の削除をキャンセルする(): void {
    this.削除対象 = null;
    this.削除ダイアログを閉じる();
  }

  async 移動を削除する(): Promise<void> {
    this.アラートメッセージ = [];
    if (this.削除対象 === null) return;
    const 移動修正削除依頼: 移動削除依頼型 = {
      部署間移動シーケンス番号: this.削除対象.移動.部署間移動シーケンス番号,
      更新バージョン: this.削除対象.移動.更新バージョン,
      移動入力方法区分: this.削除対象.移動.入力方法,
    };

    const 削除処理 = async (): Promise<void> => {
      await api.移動を削除する(移動修正削除依頼)
        .then(async (response: void) => {
          await this.reload();
        }).catch((error: any) => {
          this.showAlert(error.data.message);
        });
      this.削除対象 = null;
    };

    await progress(削除処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
    this.削除ダイアログを閉じる();
  }

  部署間移動修正の確定対象が存在する(): boolean {
    const 対象修正移動一覧 = this.修正対象.filter((対象修正移動) => {
      return 対象修正移動.確定対象;
    });
    for (const 修正移動 of 対象修正移動一覧) {
      if (this.修正あり(修正移動)) return true;
    }
    return false;
  }

  async 移動の修正を確定する(): Promise<void> {
    if (!this.部署間移動修正の確定対象が存在する()) {
      this.showAlert('部署間移動修正の確定対象が存在しません');
      return;
    }

    const checker = new 部署間移動修正チェッカー();
    checker.validateList(this.修正対象, this.バラ管理である, this.在庫場所選択);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }

    await progress(this.確定処理)
      .then((response: any) => {
        viewEditingStateModule.画面の編集を終了する();
      }).catch((error: any) => {
        return;
      });
  }

  移動の修正をキャンセルする(): void {
    this.確定ダイアログを閉じる();
  }

  async 確定処理(): Promise<void> {
    this.アラートメッセージ = [];
    const 移動修正依頼: 移動修正依頼型 = {
      移動修正一覧: [],
    };

    移動修正依頼.移動修正一覧 = this.修正対象
      .filter((対象修正移動) => 対象修正移動.確定対象 && this.修正あり(対象修正移動))
      .map((対象修正移動) => to移動修正依頼内容型(対象修正移動));

    await api.移動を修正する(移動修正依頼)
      .then(async () => {
        await this.reload();
      })
      .catch((error: any) => {
        if (error.data.errors) {
          this.showAlert(error.data.errors);
          return;
        }
        if (error.data.message && !error.data.errors) {
          this.showAlert(error.data.message);
        }
      });
  }

  async reload(): Promise<void> {
    if (this.検索結果に対応する検索条件 === null) return;
    this.検索条件 = this.検索結果に対応する検索条件;
    await api.移動修正一覧を取得する(this.検索結果に対応する検索条件)
      .then((response: 移動修正検索結果型) => {
        this.検索結果 = response.移動修正検索結果一覧;
        this.修正対象 = response.移動修正検索結果一覧.map((record) => to修正移動型(record));
      });
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('移動修正削除アラート');
  }

  // lifecycle hook
  async mounted(): Promise<void> {
    await this.在庫場所一覧取得();
    this.移動先在庫場所一覧を作成する();
  }

  private 移動先在庫場所一覧を作成する() {
    this.移動先在庫場所一覧 = this.在庫場所一覧.filter((it) => it.部署コード !== this.在庫場所選択.部署コード);
  }
}
